import { ArrayUtil } from "../../../util/collection/ArrayUtil";
/**
 * FontBaseline.ts
 */
export class FontBaseline {
}
FontBaseline.TOP = "top"; //all under the line
FontBaseline.BOTTOM = "bottom"; //all over the line
FontBaseline.MIDDLE = "middle"; //down the middle
FontBaseline.ALPHABETIC = "alphabetic"; //p's and q's go under the line
FontBaseline.HANGING = "hanging"; //i's and j's go over the line
/**
 * FontWeight.ts
 */
export class FontWeight {
}
FontWeight.NORMAL = "normal";
FontWeight.BOLD = "bold";
/**
 * FontName.ts
 */
export class Font {
    constructor(family, scale = 1, numbersOnly = false) {
        this.family = family;
        this.weight = FontWeight.NORMAL;
        this.baseline = 0;
        this.paddingPercentage = 0;
        this.scale = scale;
        this.numbersOnly = numbersOnly;
    }
    equals(other) {
        return (this.family === other.family &&
            this.weight === other.weight &&
            this.baseline === other.baseline &&
            this.paddingPercentage === other.paddingPercentage &&
            this.scale === other.scale);
    }
    hasScale() {
        return this.scale != 1;
    }
    setWeight(value) {
        this.weight = value;
        return this;
    }
    setBaseLine(value) {
        this.baseline = value;
        return this;
    }
    setPaddingPercentage(value) {
        this.paddingPercentage = value;
        return this;
    }
}
/**
 * FontStroke.ts
 */
export class FontStroke {
    constructor(colour, thickness) {
        this.colour = colour;
        this.thickness = thickness;
    }
    equals(other) {
        return (this.colour === other.colour && this.thickness === other.thickness);
    }
}
/**
 * FontShadow.ts
 */
export class FontShadow {
    constructor(colour, distance, angle = 45, alpha = 1, blur = 0) {
        this.colour = colour;
        this.distance = distance;
        this.angle = angle;
        this.alpha = alpha;
        this.blur = blur;
    }
    equals(other) {
        return (this.colour === other.colour &&
            this.distance === other.distance &&
            this.angle === other.angle &&
            this.alpha === other.alpha &&
            this.blur === other.blur);
    }
}
/*
 * FontProperties.ts
 */
export class FontProperties {
    constructor(font, size, colour, uppercase = false) {
        this.font = font;
        this.size = size;
        this.colour = colour;
        this.gradientStops = [];
        this.uppercase = uppercase;
        this.lowercase = false;
        this.lineJoin = "round";
        this.miterLimit = 10;
        this.leading = 0;
        this.letterSpacing = 0;
        this.lineHeight = 0;
        this.textBaseline = FontBaseline.ALPHABETIC;
        this.trim = false;
    }
    equals(other) {
        return (this.font.equals(other.font) &&
            this.size === other.size &&
            this.colour === other.colour &&
            ArrayUtil.equals(this.gradientStops, other.gradientStops) &&
            this.uppercase === other.uppercase &&
            this.lowercase === other.lowercase &&
            this.lineJoin === other.lineJoin &&
            this.miterLimit === other.miterLimit &&
            this.leading === other.leading &&
            this.letterSpacing === other.letterSpacing &&
            this.textBaseline === other.textBaseline &&
            this.trim === other.trim);
    }
    setMiterLimit(value) {
        this.miterLimit = value;
        return this;
    }
    setLeading(value) {
        this.leading = value;
        return this;
    }
    setLetterSpacing(value) {
        this.letterSpacing = value;
        return this;
    }
    setLineHeight(value) {
        this.lineHeight = value;
        return this;
    }
    setTextBaseline(value) {
        this.textBaseline = value;
        return this;
    }
    /**
     * Trims transparent borders from `PIXI.Text` after it is rendered
     * @param value - Whether to trim or not.
     */
    setTrim(value) {
        this.trim = value;
        return this;
    }
    addStroke(stroke) {
        if (stroke) {
            this.stroke = stroke;
        }
        return this;
    }
    addDropShadow(shadow) {
        if (shadow) {
            this.dropShadow = shadow;
        }
        return this;
    }
    addGradientStops(stops) {
        if (stops && stops.length) {
            this.gradientStops = stops.slice();
        }
        return this;
    }
}
//# sourceMappingURL=FontProperties.js.map